import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

import { AppRoute } from "../types";

import { privateRoutes } from "./private";
import { publicRoutes } from "./public";

export const appRoutes: AppRoute[] = [
  {
    path: paths.app.root.path,
    page: lazy(() => import("@/app").then((module) => ({ default: module.App }))),
    children: [
      {
        index: true,
        page: lazy(() => import("../components/Redirect").then((module) => ({ default: module.Redirect }))),
      },
      ...publicRoutes,
      ...privateRoutes,
      {
        path: "*",
        page: lazy(() => import("@/components/views/errors/Error404").then((module) => ({ default: module.Error404 }))),
      },
    ],
  },
];
